const environments = {
  'localhost': { api: 'http://localhost:3003/api/v1', hostname: 'http://localhost:8081' },
  'homelab':  { api: 'http://192.168.25.3:3003/api/v1', hostname: 'http://192.168.25.3:8079' },
  'dev': { api: 'https://giser-unf-api.srv.apdev.men/api/v1', hostname: 'https://giser-unf.srv.apdev.men' },
  'qa':       { api: 'https://unf-qa.apdev.men/api/v1', hostname: 'https://qa.gestionuniformes.cl' },
  'prod':     { api: 'https://api-prod.gestionuniformes.cl/api/v1', hostname: 'https://app.gestionuniformes.cl' }
};

const patterns = [
  { key: 'app',      env: 'prod' },
  { key: 'srv',      env: 'dev' },
  { key: 'qa',      env: 'qa' },
  { key: 'localhost', env: 'localhost' },
  { key: '192',      env: 'homelab' }
];

function detectEnvironment() {
  const host = window.location.hostname;
  const match = patterns.find(p => host.includes(p.key));
  return environments[match?.env ?? 'prod'];
}

export default detectEnvironment;
